<template>
  <div class="row">
    <div class="col-12">
      <filter-component />
      <main-chart v-if="items.length" class="mb-4" />
      <table-component />
    </div>
  </div>
</template>

<script>
  import FilterComponent from '@phone-number/components/numbers-stats-general-table-filter';
  import MainChart from '@phone-number/components/numbers-stats-general-chart-main';
  import TableComponent from '@phone-number/components/numbers-stats-general-table';
  import { mapGetters } from 'vuex';
  import { DATA } from '@/plugins/vuex-async-pagginate';

  export default {
    components: {
      FilterComponent,
      MainChart,
      TableComponent
    },

    computed: {
      ...mapGetters('phone-number/stats/general', { items: DATA })
    }
  };
</script>
